import React, { Component } from "react";
import { connect } from "react-redux";
import ItemPreview from "./ItemPreview";
import Loader from "./utils/Loader";

// State
import { getSuggestedProducts } from "./../store/actions/suggestedProducts";

// CSS
import "./../css/suggested-products.css";

// Utils
import isEqual from "lodash/isEqual";

class SuggestedProducts extends Component {
	fetchData(permalink) {
		this.props.getSuggestedProducts(permalink);
	}

	componentDidMount() {
		this.fetchData(this.props.permalink);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.permalink !== this.props.permalink) {
			this.fetchData(nextProps.permalink);
		}
	}

	showSuggestedProducts() {
		if (this.props.suggestedProducts.isLoading) {
			return (
				<div className="pt2">
					<Loader />
				</div>
			);
		} else if (this.props.suggestedProducts.products.length) {
			return (
				<div className="collection">
					{this.props.suggestedProducts.products.map((product, i) => {
						return <ItemPreview key={i} product={product} width={92} height={92} />;
					})}
				</div>
			);
		} else {
			return <div className="pt2 centered">Please check back for products soon!</div>;
		}
	}

	render() {
		const products = this.props.suggestedProducts.products;

		if (products) {
			return (
				<div className="suggestion_section">
					<div className="title">Customers also loved</div>

					<div className="product_collection">{this.showSuggestedProducts()}</div>
				</div>
			);
		} else {
			return null;
		}
	}
}

const mapStateToProps = state => {
	return {
		// siteInfo: state.siteInfo,
		suggestedProducts: state.suggestedProducts
	};
};

export default connect(
	mapStateToProps,
	{ getSuggestedProducts }
)(SuggestedProducts);



// WEBPACK FOOTER //
// ./src/components/SuggestedProducts.js